


















import { Vue, Component } from 'vue-property-decorator'
@Component({
  name: 'DeveloperPrivate'
})
export default class extends Vue {}
